module.exports = __webpack_public_path__ + "r-v3/img/mic_off_red.7dd3b42d.svg";